import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({submitting, triggerSubmit}) => (
  <div className="Buttons">
    <Button
      className="createButton"
      blue={!submitting}
      onClick={triggerSubmit}
      isLoading={submitting}
      disabled={submitting}>
      Create
    </Button>
  </div>
);

export default Buttons;
